import { render, staticRenderFns } from "./HirePackage.vue?vue&type=template&id=70d5fda7&"
import script from "./HirePackage.vue?vue&type=script&lang=js&"
export * from "./HirePackage.vue?vue&type=script&lang=js&"
import style0 from "./HirePackage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports